import { render, staticRenderFns } from "./ForgotPasswordConfirmation.vue?vue&type=template&id=45a54039&scoped=true&"
import script from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a54039",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
